import { Trans } from '@lingui/macro';
import { Loader } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { AssistantPromptButton, AssistantViewType, useAssistant } from 'app/domains/assistant';
import { DocumentChatMessageType } from 'shared/domains/apollo/generated/types';
import { Section } from '../Section';
export function DocumentPrompts() {
    const { addComment, requestSuggestions, fetchingSuggestions, updateView } = useAssistant();
    return (<Section>
      <AssistantPromptButton title={<Trans comment="Document Assistant predefined prompts - suggest clause">
            Suggest clause
          </Trans>} leftIcon={<Falcon icon="section"/>} onClick={() => addComment({
            type: DocumentChatMessageType.DocumentSuggest,
        })}/>
      <AssistantPromptButton title={<Trans comment="Document Assistant predefined prompts - ask questions">
            Ask questions
          </Trans>} leftIcon={<Falcon icon="question"/>} rightIcon={fetchingSuggestions ? <Loader /> : undefined} onClick={() => fetchingSuggestions ? updateView(AssistantViewType.Suggestions) : requestSuggestions()}/>
      <AssistantPromptButton title={<Trans comment="Document Assistant predefined prompts - summarize">Summarize</Trans>} leftIcon={<Falcon icon="bolt"/>} onClick={() => addComment({
            type: DocumentChatMessageType.DocumentSummarize,
        })}/>
      <AssistantPromptButton title={<Trans comment="Document Assistant predefined prompts - negotiation support">
            Negotiation support
          </Trans>} leftIcon={<Falcon icon="eye"/>} rightIcon={<Falcon icon="clock" $size={12}/>} disabled/>
    </Section>);
}
